import { render } from "./ZWideSection.vue?vue&type=template&id=3253d03c"
import script from "./ZWideSection.vue?vue&type=script&lang=js"
export * from "./ZWideSection.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__